import api from './api';
import type { ClinicInvoice, PaginatedResponse } from '@/types';

export interface ListInvoicesParams {
  clinicId?: string;
  status?: string;
  page?: number;
  limit?: number;
}

export interface GenerateInvoiceDto {
  clinicId: string;
  periodStart: string;
  periodEnd: string;
}

export interface BillingStats {
  totalOutstanding: number;
  totalOverdue: number;
  totalPaidThisMonth: number;
  invoiceCount: number;
}

export interface ClinicBilling {
  clinic: { id: string; name: string };
  invoices: ClinicInvoice[];
  totalOutstanding: number;
}

export const billingApi = {
  getStats: async () => {
    const response = await api.get<BillingStats>('/billing/stats');
    return response.data;
  },
  listInvoices: async (params: ListInvoicesParams = {}) => {
    const response = await api.get<PaginatedResponse<ClinicInvoice>>('/billing/invoices', { params });
    return response.data;
  },
  getInvoice: async (id: string) => {
    const response = await api.get<ClinicInvoice>(`/billing/invoices/${id}`);
    return response.data;
  },
  generateInvoice: async (dto: GenerateInvoiceDto) => {
    const response = await api.post<ClinicInvoice>('/billing/invoices/generate', dto);
    return response.data;
  },
  markSent: async (id: string) => {
    const response = await api.post<ClinicInvoice>(`/billing/invoices/${id}/send`);
    return response.data;
  },
  markPaid: async (id: string, paidAt?: string) => {
    const response = await api.post<ClinicInvoice>(`/billing/invoices/${id}/pay`, { paidAt });
    return response.data;
  },
  voidInvoice: async (id: string, reason: string) => {
    const response = await api.post<ClinicInvoice>(`/billing/invoices/${id}/void`, { reason });
    return response.data;
  },
  getPrintUrl: (id: string) => `/api/billing/invoices/${id}/print`,
  getClinicBilling: async (clinicId: string) => {
    const response = await api.get<ClinicBilling>(`/billing/clinic/${clinicId}`);
    return response.data;
  },
};

export default billingApi;
